import { connectApi } from "@api/coreApi";
import { baseURL } from "@api/endpoints";

export const getChannel = () =>
  connectApi({
    method: "GET",
    url: `${baseURL.getChannel}`,
  });

export const getLocationByType = ({ type }) =>
  connectApi({
    method: "GET",
    url: `${baseURL.getLocationByType}?type=${type}`,
  });

export const getOptionData = ({ type }) =>
  connectApi({
    method: "GET",
    url: `${baseURL.getOptionData}?type=${type}`,
  });

export const updatePopupCount = (payload) =>
  connectApi({ method: "POST", url: baseURL.updatePopupCount, payload });
